<script>
  import {External} from "../external";

  export let config,
    onComplete,
    file = null;

  function onClick() {
    External.FileManager.selectFile({
      listImagesOnly: config.imagesOnly || false,
      onCompleteCallback: function (fileBase, pickedFile) {
        onComplete(fileBase, pickedFile);
      }
    });
  }
</script>

<input on:click={onClick} placeholder={file || config.placeholder} class="template-select select-like image-selector" readonly="readonly" />
